import { Model } from '@vuex-orm/core'
import Role from '@/store/models/Role'

export default class ManagedUser extends Model {
  static entity = 'managedUsers'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      email: this.string(''),
      firstName: this.string(''),
      lastName: this.string(''),
      defaultOrganizationId: this.attr(null),
      currentOrganizationRoleId: this.attr(null),
      meta: this.attr(null)
    }
  }

  currentOrganizationRole() {
    return Role.find(this.currentOrganizationRoleId)
  }
}
